import { SalesRoutingModule } from './sales.routing.module';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedAppModule } from '../app.module.shared';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// SALES COMPONENTS
import { SalesReportComponent } from './sales.report/sales.report.component';
import { SalesProductSettingsComponent } from './sales.product.settings/sales.product.settings.component';

@NgModule({
    declarations: [
        SalesReportComponent,
        SalesProductSettingsComponent
    ],
    imports: [
        CommonModule,
        SharedAppModule,
        ReactiveFormsModule,
        FormsModule,

        SalesRoutingModule
    ],
    entryComponents: [

    ]
})

export class SalesModule { }
